import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { DatadogRumInitializer } from '../../components/datadog/DatadogRumInitializer';

const datadogRumRootWrapper = AppRootWrapperBlueprint.make({
  name: 'datadog-rum',
  params: {
    component: DatadogRumInitializer,
  },
});

export const datadogRumModule = createFrontendModule({
  pluginId: 'app',
  extensions: [datadogRumRootWrapper],
});
